import { createApp } from "vue";
import AddonsModal from "@/components/AddonsModal.vue";

export default {
    install(app) {
        const div = document.createElement("div");
        document.body.appendChild(div);

        // สร้าง instance ของ modal
        const modalApp = createApp(AddonsModal);
        const modalInstance = modalApp.mount(div);
        modalApp.config.globalProperties = app.config.globalProperties;
        // เพิ่ม global function
        app.config.globalProperties.$addons = {
            open(options) {
                if (modalInstance && modalInstance.open) {
                    modalInstance.open(options);
                } else {
                    console.error("⚠️ AddonsModal.vue: ไม่มี method open()");
                }
            },
            close() {
                if (modalInstance && modalInstance.close) {
                    modalInstance.close();
                } else {
                    console.error("⚠️ AddonsModal.vue: ไม่มี method close()");
                }
            }
        };
    }
};
